// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Customers-CustomerList-ListLoyalty-ActionBar-__ActionBar___2FEwK","li-filter":"app-pages-Customers-CustomerList-ListLoyalty-ActionBar-__ActionBar___23HWm"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Customers/CustomerList/ListLoyalty/ActionBar/ActionBar.css
// module id = 2294
// module chunks = 0